import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowDropUp,
  Facebook,
  Instagram,
  WhatsApp,
  X,
} from "@mui/icons-material";
// IMAGE
import payall from "../assets/icons/payall.png";

const Footer = () => (
  <footer className="bg-coffeeBrown  text-white ">
    <div className="flex bg-coffee py-2 mx-auto justify-center ">
      <a href="#top" className="text-small hover:text-white">
        <ArrowDropUp /> Back to top
      </a>
    </div>

    <div className="hidden md:block lg:block xl:block 2xl:block">
      <div className="container mx-8 py-8 grid md:grid-cols-4 gap-4  ">
        <div>
          <h3 className="font-bold text-small mb-2">Help & Support</h3>
          <ul className="text-small hover:text-white">
            <li>
              <Link to="/settings/help" className="text-small hover:text-white">
                Help Center
              </Link>
            </li>
            <li>
              <Link
                to="/settings/returnPolicy"
                className="text-small hover:text-white"
              >
                Returns & Warranty
              </Link>
            </li>
            <li>
              <Link
                to="/settings/privacyPolicy"
                className="text-small hover:text-white"
              >
                Privacy Policy
              </Link>
            </li>

            <li className="flex gap-2">
              <a href="x.com">
                <X fontSize="small" />
              </a>
              <a href="instagram.com">
                <Instagram fontSize="small" />
              </a>
              <a href="facebook.com">
                <Facebook fontSize="small" />
              </a>
              <a href="whatsApp.com">
                <WhatsApp fontSize="small" />
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="font-bold text-small mb-2 ">Company Info</h3>
          <ul>
            <li>
              <Link
                to="/settings/about"
                className="text-small hover:text-white"
              >
                About Tobikor
              </Link>
            </li>
            <li>
              <Link to="/sellRegister" className="text-small hover:text-white">
                Sell on Tobikor
              </Link>
            </li>
            <li>
              <Link
                to="/settings/about"
                className="text-small hover:text-white"
              >
                Contacts
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-bold text-small mb-2">Customer Service</h3>
          <ul>
            <li>
              <Link
                to="/settings/track"
                className="text-small hover:text-white"
              >
                Tracking
              </Link>
            </li>
            <li>
              <Link to="/settings/help" className="text-small hover:text-white">
                How to order
              </Link>
            </li>
            <li>
              <Link to="/settings/help" className="text-small hover:text-white">
                Payment Methods
              </Link>
            </li>
          </ul>
        </div>

        <div className="">
          <div className="mt-8 p-4 flex justify-between border border-gray-400 shadow-md rounded-md ">
            <img src={payall} alt="momo" className="h-8 w-auto" />
          </div>
        </div>
      </div>
    </div>

    <div className="container mx-8 py-4 flex flex-row gap-4 lg:hidden md:hidden xl:hidden 2xl:hidden">
      <div>
        <h3 className="font-bold text-small mb-2">Help & Support</h3>
        <ul className="text-small hover:text-white">
          <li>
            <Link to="/settings/help" className="text-small hover:text-white">
              Help Center
            </Link>
          </li>
          <li>
            <Link
              to="/settings/returnPolicy"
              className="text-small hover:text-white"
            >
              Returns & Warranty
            </Link>
          </li>
          <li>
            <Link
              to="/settings/privacyPolicy"
              className="text-small hover:text-white"
            >
              Privacy Policy
            </Link>
          </li>

          <li className="flex gap-2">
            <a href="x.com">
              <X fontSize="small" />
            </a>
            <a href="instagram.com">
              <Instagram fontSize="small" />
            </a>
            <a href="facebook.com">
              <Facebook fontSize="small" />
            </a>
            <a href="whatsApp.com">
              <WhatsApp fontSize="small" />
            </a>
          </li>
        </ul>
      </div>
      <div className="mt-2 p-2 flex flex-col justify-between ">
        <img src={payall} alt="momo" className="h-6 w-auto" />
      </div>
    </div>
    <div className="bg-coffee py-4">
      <div className="  flex mx-auto justify-center">
        <Link to="/settings/terms" className="text-small p-2 hover:text-white">
          Terms and Conditions
        </Link>
        <Link
          to="/settings/privacyPolicy"
          className="text-small p-2 hover:text-white"
        >
          Privecy Policy
        </Link>
        <Link
          to="/settings/returnPolicy"
          className="text-small p-2 hover:text-white"
        >
          Returns & Refunds
        </Link>
        <Link to="/sellRegister" className="text-small p-2 hover:text-white">
          Sell on Tobikor
        </Link>
      </div>
      <div className="container mx-auto text-small text-center">
        &copy; {new Date().getFullYear()} Tobikor Online Shop. All Rights
        Reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
